import { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import FormContainer from '../Components/FormContainer';

export default function VerifyEmailScreen() {
  const { search } = useLocation();
  const navigate = useNavigate();
  const email = new URLSearchParams(search).get('email') || '';
  const [code, setCode] = useState('');
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const submitHandler = async (e) => {
    e.preventDefault(); setErr(''); setMsg(''); setBusy(true);
    try {
      const res = await fetch('/api/users/verify-email', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, code }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.message || 'Verification failed');
      setMsg('Verified! You can now log in.'); setTimeout(()=>navigate('/login'), 800);
    } catch (e) { setErr(e.message); } finally { setBusy(false); }
  };

  const resend = async () => {
    setErr(''); setMsg(''); setBusy(true);
    try {
      const res = await fetch('/api/users/resend-verification', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.message || 'Resend failed');
      setMsg('New code sent to your email.');
    } catch (e) { setErr(e.message); } finally { setBusy(false); }
  };

  return (
    <FormContainer>
      <h1>Verify your email</h1>
      {email && <p className="text-muted">Code sent to <b>{email}</b></p>}
      {msg && <Alert variant="success">{msg}</Alert>}
      {err && <Alert variant="danger">{err}</Alert>}
      <Form onSubmit={submitHandler}>
        <Form.Group className="my-2">
          <Form.Label>6-digit code</Form.Label>
          <Form.Control type="text" inputMode="numeric" value={code} onChange={(e)=>setCode(e.target.value)} maxLength={6} required />
        </Form.Group>
        <Button type="submit" className="mt-2" disabled={busy}>Verify</Button>
        <Button type="button" variant="link" className="mt-2" onClick={resend} disabled={busy}>Resend code</Button>
      </Form>
    </FormContainer>
  );
}
